export class CalfCondition {
    public static readonly ALIVE = new CalfCondition('ALIVE', 'Vivo');
    public static readonly DEAD = new CalfCondition('DEAD', 'Morto');

    public constructor(
        public readonly name: string,
        public readonly label: string
    ) { }

    public static values(): CalfCondition[] {
        return [CalfCondition.ALIVE, CalfCondition.DEAD];
    }

    public static get(name: string): CalfCondition {
        const type = CalfCondition.values().find((it) => it.name === name);
        if (type == null) {
            throw new Error(`${name} is not a mapped CalfCondition.`);
        };
        return type;
    }
}
